import React from 'react';
import { Grid2 } from '@mui/material';
import logo from '../../images/logo.png';

interface SingleFormProps {
  title: string;
  children?: React.ReactNode;
  onSubmit?: (e: React.FormEvent<HTMLFormElement>) => void;
}

const SingleForm: React.FC<SingleFormProps> = ({ title, children, onSubmit }) => (
  <Grid2
    container
    sx={{
      height: "100vh",
      overflowY: "auto",
      mt: 4
    }}
  >
    <Grid2 container spacing={4} flexDirection="column" sx={{ width: "600px", margin: "0 auto" }}>
      <img src={logo} width="300px" alt="logo" style={{ alignSelf: "center" }} />
      <h1>{title}</h1>
      <form
        style={{ width: "100%" }}
        onSubmit={onSubmit}
      >
        <Grid2 container spacing={4} flexDirection="column">
          {children}
        </Grid2>
      </form>
    </Grid2>
  </Grid2>
);

export default SingleForm;
